import { REVISIONES } from '../actions/types';

const initialState = {
    listado: [],
    informacion: null
};

export default (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case REVISIONES.BUSCAR:
            return { ...state, listado: payload };

        case REVISIONES.INFORMACION:
        case REVISIONES.CONFIRMAR:
            return { ...state, informacion: payload };

        case REVISIONES.LIMPIAR:
            return { ...state, informacion: null };

        default:
            return state;
    }
};
